export enum SiteTypes {
  Farkop,
  Baltex,
  Landing,
}

const initialState = {
  siteType: SiteTypes.Farkop,
  host: "",
  // Вариант Roistat А/Б-теста кнопки «В корзину без установки», см. utils/abTests.ts
  abCartNoInstall: "",
};

export const paramsReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case "SET_SITE_TYPE":
      return { ...state, siteType: action.payload };
    case "SET_HOST":
      return { ...state, host: action.payload };
    case "SET_AB_CART_NO_INSTALL":
      return { ...state, abCartNoInstall: action.payload };
    default:
      return state;
  }
};
